@if (shouldRender) {
    <nav class="page-breadcrumb" [attr.aria-label]="ariaLabelKey | transloco">
        @for (item of items; track $index; let last = $last) {
            @if ($index > 0) {
                <mat-icon class="page-breadcrumb__separator" aria-hidden="true">chevron_right</mat-icon>
            }
            @if (item.link && !last) {
                <a class="page-breadcrumb__link" [routerLink]="item.link">
                    @if (item.labelKey) {
                        {{ item.labelKey | transloco }}
                    } @else {
                        {{ item.label }}
                    }
                </a>
            } @else {
                <span class="page-breadcrumb__current" [attr.aria-current]="last ? 'page' : null">
                    @if (item.labelKey) {
                        {{ item.labelKey | transloco }}
                    } @else {
                        {{ item.label }}
                    }
                </span>
            }
        }
    </nav>
}
